// extracted by mini-css-extract-plugin
export default {"image":"background__image__XGg0r","color":"background__color__a9rPB","video":"background__video__iywIJ","videoEnabled":"background__videoEnabled__HIZMX"};